import { useRouter } from "next/router";

const Success = (props) =>{

    const router = useRouter();
    
    if(props.title=="success"){
       if(props.frompage=="Contactpage"){
        router.push("contact-us-thankyou");
       }
       else if(props.frompage=="tnpscprelimsMocktest"){
        router.push("tnpsc-group-II-IIA-prelims-mock-test-thankyou");
       }
       else if(props.frompage=="tnpscmainsmocktest"){
        router.push("tnpsc-group-I-mains-mock-test-thankyou");
       }
        else if(props.frompage=="tnusrbsimocktest"){
        router.push("tnusrb-si-mock-test-thankyou");
       }
       else if(props.frompage=="UPSCleadform"){
        router.push("best-upsc-coaching-centre-thankyou");
       }
       else if(props.frompage=="SIAUPSCMainsMockTest"){
        router.push("upsc-all-india-mains-mocktest-thank-you");
       }
       else if(props.frompage=="setuscholarshiptest"){
        router.push("upsc-setu-scholarship-test-thankyou");
       }
       else if(props.frompage=="Chakraadmission"){
        router.push("current-affairs-upsc-thankyou");
       }
       else if(props.frompage=="CareersForm"){
        router.push("careers-thankyou");
       }
       else if(props.frompage=="ifsinterview2023"){
        router.push("ifs-interview-thankyou");
       }
       else if(props.frompage=="interview2022FreeCoaching"){
        router.push("interview-thankyou");
       }
       else if(props.frompage=="PracticalGuideToAnswerWriting"){
        router.push("practical-guide-to-answer-writing-thankyou");
       }
       else if(props.frompage=="upsc prefit test 2023"){
        router.push("prefit-thankyou");
       }
       else if(props.frompage=="upsc orientation program 2026"){
        router.push("orientation-thankyou");
       }
       else if(props.frompage=="Upscprelimstestseries2025"){
        router.push("upsc-prestorming-prelims-test-series-thankyou");
       }
       else if(props.frompage=="SIAUPSCMainsTestCenter"){
        router.push("upsc-mains-mocktest-thank-you");
       }
       else if(props.frompage=="TnpscgroupIandIIpreliminary"){
        router.push("ssc-banking-thankyou");
       }
       else if(props.frompage=="UPSCclassroomandonline"){
        router.push("upsc-thank-you");
       }
        else if(props.frompage=="UPSCsiamentoring"){
        router.push("sia-mentoring-thankyou");
       }
       else if(props.frompage=="Moksha Orientation Registration Form"){
        router.push("upsc-thank-you");
       }
       else if(props.frompage=="admissionconsultation"){
        router.push("tnpsc-thankyou");
       }
       else if(props.frompage=="sadhanaupsc"){
        router.push("upsc-thank-you");
       }
       else if(props.frompage=="Environmentbook"){
        router.push("upsc-makepayment");
       }
       else if(props.frompage=="DuePayment"){
        router.push("due-payment-thankyou");
       }
       else if(props.frompage=="Delhischolarshiptest"){
        router.push("delhi-scholarship-thankyou");
       }
       else if(props.frompage=="UPSCprelimsmocktest26"){
        router.push("all-india-prelims-thank-you");
       }
       else if(props.frompage=="summercamp"){
        router.push("upsc-thank-you");
       }
       
       else if(props.frompage=="tnpscmainsiimocktest"){
        router.push("tnpsc-group-II-IIA-mains-mock-test-thankyou");
       }
       

    }
       else{
            if(props.title=="failure"){
            router.push("failure-response");
        }      
     }
    return(
        <>
        </>
    )
}
export default Success;

